const availableSvg = `
    <svg aria-hidden="true" focusable="false" fill="none" width="15px" viewBox="0 0 13 9">
        <path fill="none" d="M1 4l4 4 7-7" stroke="currentColor" stroke-linecap="square"></path>
    </svg>
`;

const notAvailableSvg = `
    <svg aria-hidden="true" focusable="false" fill="none" width="15px" viewBox="0 0 16 16">
        <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="{{ stroke_width | default: settings.icon_stroke_width }}"/>
    </svg>
`;

const findInStoreQuery = ({ ids, latitude, longitude }) => {
    return `
        {
            nodes(ids: ["${ids.join('","')}"]) {
                ... on Product {
                    id
                    variants(first: 250) {
                        edges {
                            node {
                                id
                                storeAvailability(first: 250, near: { latitude: ${latitude}, longitude: ${longitude} }) {
                                    edges {
                                        node {
                                            available
                                            location {
                                                id
                                                name
                                                address {
                                                    longitude
                                                    latitude
                                                    formatted
                                                    phone
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
};

// Gets users coordinates based on there postcode
window.getCoordinatesByPostcode = async function getCoordinatesByPostcode(postcode) {
    const country = isNZ() ? "New Zealand" : "Australia";

    const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${postcode},${country}&key=AIzaSyAfv1LNQJgzw6UKbIE0LqRdmFMupVCdoSQ`
    );
    const data = await response.json();
    const location = data?.results[0]?.geometry?.location;
    return location;
};

// Get distance between two coordinates
const getDistance = (pos1, pos2) => {
    if (!pos1 || !pos2) {
        return 0;
    }

    const deg2rad = (deg) => deg * (Math.PI / 180);

    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(pos2.lat - pos1.lat);
    const dLon = deg2rad(pos2.lng - pos1.lng);

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(deg2rad(pos1.lat)) *
        Math.cos(deg2rad(pos2.lat)) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
};

window.getInventoryByLocation = async function getInventoryByLocation({ ids, latitude, longitude }) {
    const query = findInStoreQuery({
        ids: ids
            .filter((id) => !isNaN(id))
            .map((id) => `gid://shopify/Product/${id}`),
        latitude,
        longitude,
    });

    const [res, error] = await requestHandler(
        storeFrontInstance("api/2023-01/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": storeFrontAccessToken(),
            },
            body: JSON.stringify({ query }),
        })
    );

    if (error) return [];

    const products = res?.data?.nodes?.map(({ id, variants }) => ({
        id: parseInt(id.replace("gid://shopify/Product/", "")),
        variants: variants?.edges?.map(({ node }) => ({
            id: parseInt(node.id.replace("gid://shopify/ProductVariant/", "")),
            storeAvailability: node.storeAvailability?.edges
                ?.map(({ node: { available, location } }) => ({
                    id: parseInt(location.id.replace("gid://shopify/Location/", "")),
                    name: location.name,
                    ...location.address,
                    available,
                    stockStatus: available ? "In Stock" : "Out of Stock",
                    distance: getDistance(
                        { lat: latitude, lng: longitude },
                        { lat: location.address.latitude, lng: location.address.longitude }
                    ),
                }))
                .sort((a, b) => parseInt(a?.distance) - parseInt(b?.distance)),
        })),
    }));

    return products;
};

function getVariantFromUrl(url) {
    const urlObj = new URL(url);
    return urlObj.searchParams.get('variant');
}

window.locationSearchHandler = async function locationSearchHandler(
    geolocation = false,
    location,
    product,
    currentVariant,
    storeHoursData
) {
    if (!location || !product) return;

    let coordinates = {};

    if (!geolocation) {
        coordinates = await getCoordinatesByPostcode(location);
        coordinates = {
            latitude: coordinates.lat,
            longitude: coordinates.lng,
        };
    } else {
        coordinates = location;
    }

    const inventory = await getInventoryByLocation({
        ids: [product.id],
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
    });

    let currentVariantData = currentVariant
    const currentVariantId = currentVariant?.id
    const urlVariantValue = Number(getVariantFromUrl(window.location.href));

    if (urlVariantValue !== currentVariantId && urlVariantValue !== 0) {
        currentVariantData = product.variants.find(({ id }) => id === urlVariantValue) || currentVariant
    }

    const locationsData = inventory
        .find(({ id }) => id === product.id)
        .variants.find(({ id }) => id === currentVariantData?.id)
        .storeAvailability;

    const days = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
    ];

    // Unhides find in store data container
    document.querySelector(".fis-body__container").classList.remove("hidden");


    locationsData.forEach((location, index) => {
        const selectorPrefix = `[data-position="${index}"]`;

        const elements = {
            locationTitle: document.querySelector(`${selectorPrefix} .text-with-icon`),
            distanceElement: document.querySelector(`${selectorPrefix} .fis-body__distance`),
            stockElement: document.querySelector(`${selectorPrefix} .fis-body__stock`),
            deliveryElement: document.querySelector(`${selectorPrefix} .fis-body__delivery`),
            ccElement: document.querySelector(`${selectorPrefix} .fis-body__cc`),
            phoneElement: document.querySelector(`${selectorPrefix} .fis-body__phone`),
            addressElement: document.querySelector(`${selectorPrefix} .fis-body__address`),
            openHoursElement: document.querySelector(`${selectorPrefix} .fis-drawer__open-hours`),
        };

        const stockStatus = location.stockStatus === "In Stock";
        const storeHours = storeHoursData.find(store => store.store_title === location.name)?.store_hours;

        // Clear previous content before updating
        if (elements.stockElement) elements.stockElement.classList.remove('fis-available')
        if (elements.deliveryElement) elements.deliveryElement.classList.remove('fis-available')
        if (elements.ccElement) elements.ccElement.classList.remove('fis-available')
        if (elements.locationTitle) elements.locationTitle.textContent = '';
        if (elements.distanceElement) elements.distanceElement.textContent = '';
        if (elements.openHoursElement) elements.openHoursElement.innerHTML = '';

        if (elements.locationTitle) elements.locationTitle.textContent = location.name;
        if (elements.distanceElement) {
            elements.distanceElement.textContent = `${location.distance.toFixed(1)}km away`;
        }
        if (elements.phoneElement) {
            const span = elements.phoneElement.querySelector('span');
            if (span) span.innerHTML = '';
        }

        if (elements.addressElement) {
            const span = elements.addressElement.querySelector('span');
            if (span) span.innerHTML = '';
        }

        if (elements.stockElement) {
            elements.stockElement.innerHTML = `${stockStatus ? availableSvg : notAvailableSvg} ${location.stockStatus}`;
            if (stockStatus) {
                elements.stockElement.classList.add("fis-available");
            }
        }

        if (elements.deliveryElement) {
            elements.deliveryElement.innerHTML = `${currentVariantData?.available ? availableSvg : notAvailableSvg} ${currentVariantData?.available ? "Available" : "Not available"} for Delivery`;
            if (currentVariantData?.available) {
                elements.deliveryElement.classList.add("fis-available");
            }
        }

        if (elements.ccElement) {
            elements.ccElement.innerHTML = `${stockStatus ? availableSvg : notAvailableSvg} ${stockStatus ? "Available" : "Not available"} for Click & Collect`;
            if (stockStatus) {
                elements.ccElement.classList.add("fis-available");
            }
        }

        if (elements.phoneElement) {
            let span = elements.phoneElement.querySelector('span');
            span.innerHTML += location.phone || " No phone number available";
        }

        if (elements.addressElement) {
            let span = elements.addressElement.querySelector('span');
            span.innerHTML += location?.formatted.join(', ');
        }

        if (elements.openHoursElement && storeHours) {
            elements.openHoursElement.innerHTML += storeHours
                .map((day, dayIndex) =>
                    `<li class="flex justify-between"><p>${days[dayIndex]}</p><p>${day}</p></li>`
                )
                .join("");
        }
    });

    document.querySelector(".fis-body__container").classList.remove("hidden");
};



document.addEventListener('DOMContentLoaded', function () {
    // Applies click handler to show/hide opening hours
    const toggleHoursElements = document.querySelectorAll('.fis-drawer__toggle-hours');
    toggleHoursElements.forEach(toggleHours => {
        toggleHours.addEventListener('click', function () {
            const openHours = toggleHours.nextElementSibling; // Assuming openHours is the next sibling
            if (openHours && openHours.classList.contains('fis-drawer__open-hours')) {
                openHours.classList.toggle('hidden');
            }
        });
    });

});